import React from "react";

export default function DoctorRating(props) {
	const valueRounded = Math.round(props.value);
	let stars = [];

	for (let i = 0; i < 5; i++) {
		if (valueRounded <= i) {
			stars.push(<i key={i} className="fa fa-star rating-stars__muted"></i>);
			continue;
		}

		if (props.value % 1 > 0 && i === valueRounded - 1) {
			stars.push(
				<div className="rating-stars__half">
					<i key={i} className="fa fa-star rating-stars__muted"></i>
					<i key={i} className="fa fa-star-half text-warning"></i>
				</div>
			);
		} else {
			stars.push(<i key={i} className="fa fa-star text-warning"></i>);
		}
	}

	return (
		<div className="box-rating doctor">{stars}</div>
	);
}
